export class SearchController {
  constructor($scope, $route, UserService, $location, RegionService, CityService, socket, $rootScope) {
    $scope.vm = this;
    this.rootScope = $rootScope;
    this.scope = $scope;
    this.UserService = UserService;
    this.route = $route;
    this.socket = socket;
    this.location = $location;
    this.RegionService = RegionService;
    this.CityService = CityService;
    this.scope.filters = {};
    this.scope.toggle = true;

    this.scope.age = {
      grid: true,
      type: "double",
      min: 18,
      max: 99,
      from: 18,
      to: 99,
      postfix: "años",
      visible: false
    };

    this.scope.height = {
      grid: true,
      type: "double",
      min: 140,
      max: 220,
      from: 160,
      to: 200,
      postfix: "cm"
    };

    this.scope.weight = {
      grid: true,
      type: "double",
      min: 40,
      max: 200,
      from: 60,
      to: 80,
      postfix: "kg"
    };

    this.scope.regions = [];
    this.scope.allCities = [];

    this.scope.activities = [
      {
        value: 1,
        name: "Online"
      },
      {
        value: 2,
        name: "Desde hace 1 semana"
      },
      {
        value: 3,
        name: "Desde hace 2 semana"
      },
      {
        value: 4,
        name: "Desde hace 1 mes"
      }
    ];

    this.scope.interests = [
      {
        value: 1,
        name: "Pareja"
      },
      {
        value: 2,
        name: "Amigos"
      },
      {
        value: 3,
        name: "Chatear"
      }
    ];

    this.scope.switches = {
      photos: false,
      albums: false
    };

    this.scope.builds = [
      {
        value: 1,
        name: "Delgado/a"
      },
      {
        value: 2,
        name: "Atletico/a"
      },
      {
        value: 3,
        name: "Medio/a"
      },
      {
        value: 4,
        name: "Macizo/a"
      },
      {
        value: 5,
        name: "Rellenita/a"
      }
    ];

    this.scope.hairs = [
      {
        value: 1,
        name: "Negro"
      },
      {
        value: 2,
        name: "Pelirrojo"
      },
      {
        value: 3,
        name: "Castaño Claro"
      },
      {
        value: 4,
        name: "Castaño"
      },
      {
        value: 5,
        name: "Rubio"
      },
      {
        value: 6,
        name: "Rubio Oscuro"
      },
      {
        value: 7,
        name: "Castaño Oscuro"
      },
      {
        value: 8,
        name: "Gris"
      },
      {
        value: 9,
        name: "Castaño Rojizo"
      },
      {
        value: 10,
        name: "Canoso"
      },
      {
        value: 11,
        name: "Calvo"
      },
      {
        value: 12,
        name: "Otro"
      }
    ];

    this.scope.eyes = [
      {
        value: 1,
        name: "Cafe Claro"
      },
      {
        value: 2,
        name: "Cafe Oscuro"
      },
      {
        value: 3,
        name: "Azules"
      },
      {
        value: 4,
        name: "Marrones"
      },
      {
        value: 5,
        name: "Verdes"
      },
      {
        value: 6,
        name: "Grises"
      },
      {
        value: 7,
        name: "Marron Claro"
      }
    ];

    this.scope.tattoos = [
      {
        value: 1,
        name: "Ninguno"
      },
      {
        value: 2,
        name: "Visible"
      },
      {
        value: 3,
        name: "Oculto"
      },
      {
        value: 4,
        name: "Muchos"
      }
    ];

    this.scope.piercings = [
      {
        value: 1,
        name: "Ninguno"
      },
      {
        value: 2,
        name: "Las orejas"
      },
      {
        value: 3,
        name: "Ombligo"
      },
      {
        value: 4,
        name: "Otros lugares"
      }
    ];

    this.scope.martStatuses = [
      {
        value: 1,
        name: "Soltero/a"
      },
      {
        value: 2,
        name: "Relacion Libre"
      },
      {
        value: 3,
        name: "Casado/a"
      },
      {
        value: 4,
        name: "Divorciado/a"
      },
      {
        value: 5,
        name: "Viudo/a"
      },
      {
        value: 6,
        name: "Pololeando"
      }
    ];

    this.scope.children = [
      {
        value: 1,
        name: "Si, en casa"
      },
      {
        value: 2,
        name: "Si"
      },
      {
        value: 3,
        name: "De visita"
      },
      {
        value: 4,
        name: "No"
      }
    ];

    this.scope.educations = [
      {
        value: 1,
        name: "Basica"
      },
      {
        value: 2,
        name: "Media"
      },
      {
        value: 3,
        name: "Tecnica"
      },
      {
        value: 4,
        name: "Universitaria"
      },
      {
        value: 5,
        name: "Post grado"
      },
      {
        value: 6,
        name: "Otro"
      }
    ];

    this.scope.jobs = [
      {
        value: 1,
        name: "Estudiante"
      },
      {
        value: 2,
        name: "Administrativo"
      },
      {
        value: 3,
        name: "Financiero"
      },
      {
        value: 4,
        name: "Funcionario"
      },
      {
        value: 5,
        name: "Publicista"
      },
      {
        value: 6,
        name: "Marketing"
      },
      {
        value: 7,
        name: "Ingeniero"
      },
      {
        value: 8,
        name: "Educacion"
      },
      {
        value: 9,
        name: "En Tienda"
      },
      {
        value: 10,
        name: "Abogado"
      },
      {
        value: 11,
        name: "Medico"
      },
      {
        value: 12,
        name: "Construccion"
      },
      {
        value: 13,
        name: "Hoteleria"
      },
      {
        value: 14,
        name: "Turismo"
      },
      {
        value: 15,
        name: "Independiente"
      },
      {
        value: 16,
        name: "Jubilado"
      },
      {
        value: 17,
        name: "Otro"
      }
    ];

    this.scope.religions = [
      {
        value: 1,
        name: "Catolico"
      },
      {
        value: 2,
        name: "Cristiano"
      },
      {
        value: 3,
        name: "musulmán"
      },
      {
        value: 4,
        name: "Judio"
      },
      {
        value: 5,
        name: "Budista"
      },
      {
        value: 6,
        name: "Ortodoxo"
      },
      {
        value: 7,
        name: "Ateo"
      },
      {
        value: 8,
        name: "No quiero decir"
      },
      {
        value: 9,
        name: "Espiritual"
      }
    ];

    this.scope.zodiacs = [
      {
        value: 1,
        name: "Aries"
      },
      {
        value: 2,
        name: "Tauro"
      },
      {
        value: 3,
        name: "Gemenis"
      },
      {
        value: 4,
        name: "Cancer"
      },
      {
        value: 5,
        name: "Leo"
      },
      {
        value: 6,
        name: "Virgo"
      },
      {
        value: 7,
        name: "Libra"
      },
      {
        value: 8,
        name: "Escorpion"
      },
      {
        value: 9,
        name: "Sagitario"
      },
      {
        value: 10,
        name: "Capricornio"
      },
      {
        value: 11,
        name: "Aquario"
      },
      {
        value: 12,
        name: "Piscis"
      }
    ];

    this.scope.smoker = [
      {
        value: 1,
        name: "No Fumador"
      },
      {
        value: 2,
        name: "Fumador"
      },
      {
        value: 3,
        name: "Ocasionalmente"
      },
      {
        value: 4,
        name: "Intentando Dejarlo"
      }
    ];

    this.scope.searchName = "";
    this.scope.ageFiltr = {};
    this.scope.region = '';
    this.scope.city = '';
    this.scope.activity = '';
    this.scope.searching_for = '';
    this.scope.appearance = {
      height: {}, weight: {}, bodytype: '', haircolor: '',
      eyecolor: '', tattoos: '', piercings: ''
    };

    this.scope.socialInfo = {
      relshipstatus: '', edulevel: '', religion: '', children: '',
      occupation: '', zodiacsign: '', smoker: ''
    };

    this.init();
  }

  init() {
    this.scope.filterUsers = () => {
      var search = {};
      search.id = this.rootScope.currentUserProfile._id;
      search.gender = this.rootScope.currentUserProfile.gender;

      if(this.scope.searchName) {
        search.name = this.scope.searchName;
      }
      else {
        search.age = this.scope.ageFiltr;
        search.region = this.scope.region;
        search.city = this.scope.city;
        search.activity = this.scope.activity || 'Desde hace 3 mes';
        search.searching_for = this.scope.searching_for;
        search.isPhoto = this.scope.photorequired;
        search.isAlbum = this.scope.switches.albums;
        search.appearance = this.scope.appearance;
        search.socialInfo = this.scope.socialInfo;
        search.name = this.scope.searchName;
        search.permanent = false;
      }

      this.scope.filter = JSON.stringify(search);
      this.location.path( "/homerd/filtered/" + this.scope.filter.replace(/\//, '%2F') );
    };

    this.scope.getRegions = () => {
      this.RegionService.getRegionsList()
        .then((response) => { let regions = response.data;
          this.scope.regions = regions.data;
          if(this.rootScope.currentUserProfile.filters.region) {
            this.scope.region = this.rootScope.currentUserProfile.filters.region;
          }
          this.scope.getCities();
        })
        .catch((response) => { let error = response.data;
          console.log("Can`t get regions from database");
        });
    };

    this.scope.getCities = () => {
      this.CityService.getCitiesList()
        .then((response) => { let cities = response.data;
          this.scope.allCities = cities.data;
          this.scope.changeRegion();
        })
        .catch((response) => { let error = response.data;
          console.log("Can`t get cities from database");
        });
    };

    this.scope.changeRegion = () => {
      this.scope.city = null;
      this.scope.cities = [];
      var region = this.scope.region;
      _(this.scope.allCities).forEach((city) => {
        if (city.region == region) {
          this.scope.cities.push(city);
        }
      }).value();
    };

    this.scope.changeAge = (sliderObj) => {
      this.scope.ageFiltr.from=sliderObj.from;
      this.scope.ageFiltr.to=sliderObj.to;
    };

    this.scope.toggleHeight = () => {
      $('#estatura').toggleClass('hide-detailed');
    };

    this.scope.toggleSocial = () => {
      $('#social').toggleClass('hide-detailed')
    };

    this.UserService.getCurrentUser()
      .then((response) => { let user = response.data;
        this.rootScope.currentUserProfile = user.data;
        this.scope.photorequired = this.rootScope.currentUserProfile.filters.photorequired;
        this.scope.ageFiltr.from = this.rootScope.currentUserProfile.filters.minage;
        this.scope.ageFiltr.to = this.rootScope.currentUserProfile.filters.maxage;
        this.scope.age.from = this.rootScope.currentUserProfile.filters.minage;
        this.scope.age.to = this.rootScope.currentUserProfile.filters.maxage;
        this.scope.age.visible = true;

        this.scope.getRegions();
        })
        .catch((response) => { let error = response.data;
          console.log(error);
        });

        this.scope.changeAge = (sliderObj) => {
          this.scope.ageFiltr.from=sliderObj.from;
          this.scope.ageFiltr.to=sliderObj.to;
        };

        this.scope.changeHeight = (sliderObj) => {
          this.scope.appearance.height.from = sliderObj.from;
          this.scope.appearance.height.to = sliderObj.to;
        };

        this.scope.changeWeight = (sliderObj) => {
          this.scope.appearance.weight.from = sliderObj.from;
          this.scope.appearance.weight.to = sliderObj.to;
        };
    }
}
